<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .game-info__individual-settings(v-else)
        multiplayer-tiny-setting.game-info__choose-time(
            :label="`${params.speed} с`",
            :value="params.speed",
            @increase="handleSpeedIncrease",
            @decrease="handleSpeedDecrease",
            :min="seconds[0]",
            :max="seconds[seconds.length - 1]",
            :disabled="!isGamePaused",
        )
        multiplayer-tiny-setting(
            :label="`${params[amountOfNumbersParameterName]} Ч`",
            :value="params[amountOfNumbersParameterName]",
            @increase="handleAmountOfNumbersIncrease",
            @decrease="handleAmountOfNumbersDecrease",
            :min="1",
            :max="maxAmountOfNumbers",
            :disabled="!isGamePaused",
        )
        multiplayer-tiny-setting(
            :label="`${params.seriesAmount} С`",
            :value="params.seriesAmount",
            @increase="handleAmountOfSeriesIncrease",
            @decrease="handleAmountOfSeriesDecrease",
            :min="0",
            :max="20",
            :disabled="!isGamePaused",
        )
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import FlashCardsConfig from "../configs/FlashCardsConfig";

    const SERIES_PARAMETER = 'isSeries';
    const SERIES_AMOUNT_PARAMETER = 'seriesAmount';
    const SERIES_NUMBERS_AMOUNT_PARAMETER = 'seriesExamples';
    const DEFAULT_NUMBERS_AMOUNT_PARAMETER = 'amount';

    const PARAMETERS_UPDATE_EVENT = 'parametersUpdate';

    export default {
        mounted () {
            this.parameters = this.paramsArray;
            this.params = this.paramsArray[this.currentUserPosition];
            if (!this.params.isSeries) {
                this.params.seriesAmount = 0;
            }
        },
        props: {
            currentUserPosition: {
                type: Number,
                default: 0,
            },
            isGamePaused: {
                type: Boolean,
                default: false,
            }
        },
        watch: {
            parameters: {
                handler (value) {
                    if (value && value.length) {
                        this.params = value[this.currentUserPosition];
                    }
                },
                deep: true,
            },
            params: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.parameters[this.currentUserPosition] = value;
                        this.$store.dispatch('setParamsArray', this.parameters);
                        this.$emit(PARAMETERS_UPDATE_EVENT);
                    }
                },
                deep: true,
            },
            'params.isSeries' (value) {
                if (!value) {
                    this.params.seriesAmount = 0;
                }
            }
        },
        data () {
            return {
                parameters: null,
                params: null,
                seconds: FlashCardsConfig.seconds,
            }
        },
        methods: {
            handleSpeedIncrease () {
                this.params.speed = this.seconds[this.seconds.indexOf(this.params.speed) + 1];
            },
            handleSpeedDecrease () {
                this.params.speed = this.seconds[this.seconds.indexOf(this.params.speed) - 1];
            },
            handleAmountOfNumbersIncrease () {
                this.params[this.amountOfNumbersParameterName] += 1;
                this.params.infinityAmountOfExamples = false;
            },
            handleAmountOfNumbersDecrease () {
                this.params[this.amountOfNumbersParameterName] -= 1;
                this.params.infinityAmountOfExamples = false;
            },
            handleAmountOfSeriesIncrease () {
                this.params.seriesAmount += 1;
                this.params.isSeries = !!this.params.seriesAmount;
                this.params.infinityAmountOfExamples = false;
            },
            handleAmountOfSeriesDecrease () {
                this.params.seriesAmount -= 1;
                this.params.isSeries = !!this.params.seriesAmount;
                this.params.infinityAmountOfExamples = false;
            }
        },
        computed: {
            ...mapState({
                paramsArray: state => state.trainer.paramsArray,
            }),
            maxAmountOfNumbers () {
                if (this.params.isSeries) {
                    return 9;
                }
                return 100;
            },
            amountOfNumbersParameterName () {
                return this.params.isSeries
                    ? SERIES_NUMBERS_AMOUNT_PARAMETER
                    : DEFAULT_NUMBERS_AMOUNT_PARAMETER;
            }
        }
    }
</script>

<style scoped lang="scss">
    .game-info__individual-settings {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        align-self: center;
    }
</style>